import React from 'react';
import '../styles/PageContact.css';

function PageContact() {
	return (
		<div className="contact">
			<div className="contact-overlay">
				<h1>Kontakt</h1>
				<p>Skontaktuj się z nami – jesteśmy tu dla Ciebie!</p>
				<div className="card">
					<div className="card-section">
						<h2>Adres</h2>
						<p>Raba Niżna 165<br />34-730 Mszana Dolna</p>
					</div>
					<div className="card-section">
						<h2>Telefon</h2>
						<p>+48 792 825 301</p>
					</div>
					<div className="card-section">
						<h2>Email</h2>
						<p>kontakt@kwiatyzgor.pl</p>
					</div>
					<div className="card-section">
						<h2>Numer konta</h2>
						<p>47 1160 2202 0000</p>
						<p>0006 6069 6155</p>
					</div>
					<div className="card-section">
						<h2>Dane firmy</h2>
						<p>Nazwa: Kwiaty z gór Ewa Rapta</p>
						<p>NIP: 7352256512</p>
						<p>REGON: 120433000</p>
					</div>
					<div className="card-section">
						<h2>Facebook</h2>
						<p>
							<a href="https://facebook.com/Kwiatyzgor" target="_blank" rel="noopener noreferrer">
								facebook.com/Kwiatyzgor
							</a>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default PageContact;
